import { createApp, nextTick } from 'vue'
import HotelListAutomatedApp from '../HotelListAutomatedApp.vue'
import { setupCalendars } from '@common/lib-vue-common'

export const mountHotelListAutomated = () => {
  const hotelListAutomatedInstances = document.getElementsByClassName('hotel-list-automated-map')
  if (!hotelListAutomatedInstances || hotelListAutomatedInstances.length === 0) return

  Array.from(hotelListAutomatedInstances).forEach(elem => {
    const hotelListAutomatedInfo = window?.hotelListAutomated.find(
      hotelList => hotelList.type === 'MAP-LIST' && hotelList.status !== 'INIT'
    )
    if (!hotelListAutomatedInfo) return
    hotelListAutomatedInfo && (hotelListAutomatedInfo.status = 'INIT')

    const filters = {
      brand: hotelListAutomatedInfo.filters.brands,
      region: hotelListAutomatedInfo.filters.regions,
      country: hotelListAutomatedInfo.filters.countries,
      city: hotelListAutomatedInfo.filters.cities,
      status: hotelListAutomatedInfo.filters.status,
      type: hotelListAutomatedInfo.filters.types,
      service: hotelListAutomatedInfo.filters.services,
      locationType: hotelListAutomatedInfo.filters.locationTypes,
      accessibility: hotelListAutomatedInfo.filters.accessibilities,
      code: hotelListAutomatedInfo.filters.codes,
      stars: hotelListAutomatedInfo.filters.stars,
      limit: hotelListAutomatedInfo.filters.limit
    }
    const cardConfig = {
      ...hotelListAutomatedInfo.show,
      link: hotelListAutomatedInfo.customLink
    }

    const app = createApp(HotelListAutomatedApp, {
      cardConfig: cardConfig,
      filters: filters,
      layoutConfig: hotelListAutomatedInfo.layout
    })
    setupCalendars(app)

    nextTick(() => app.mount(elem))
  })
}
